import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA4N0qUCF3Bi0uSPWSMrJ7o269dU0_QNVQ",
  authDomain: "tosc25-v2.firebaseapp.com",
  projectId: "tosc25-v2",
  storageBucket: "tosc25-v2.firebasestorage.com",
  messagingSenderId: "404177413747",
  appId: "1:404177413747:web:468bcb8381fc26f7c7ac06",
  measurementId: "G-BFL28C20RN",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Force long polling to avoid WebChannel issues
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
